import React, { useState } from 'react';
import { func, string, bool, oneOfType } from 'prop-types';
import { validate as validator } from 'ui-validator';
import { CurrencyInput } from '@shared_modules/local-propulsion/components';
import { heapTrackErrors, heapTrackEvent } from '@shared_modules/baui-heap-tracking';
import { Page } from '../../components';
import validations from './income-additional-validations';

const IncomeAdditional = ({
  incomeAdditional: initialIncomeAdditional,
  saveValues,
  nextLocation,
  previousLocation,
}) => {
  const [incomeAdditional, setIncomeAdditional] = useState(initialIncomeAdditional);
  const [validationErrors, setValidationErrors] = useState({});
  const [showHelperText, setShowHelperText] = useState(false);

  const helperText = showHelperText
    ? 'Sources of income such as alimony, child support, or maintenance income are optional.'
    : '';

  const handleFocus = () => {
    setShowHelperText(true);
  };

  const handleBlur = () => {
    setShowHelperText(false);
    setValidationErrors(validator({ incomeAdditional }, validations));
  };

  const submit = e => {
    if (e) e.preventDefault();
    const errors = validator({ incomeAdditional }, validations);
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      heapTrackErrors(errors);
    } else {
      saveValues({
        incomeAdditional: {
          incomeAdditional,
        },
      });
      heapTrackEvent('Income_Additional_CTA_Click', { INCOME: incomeAdditional });
      nextLocation();
    }
  };

  return (
    <Page
      name="incomeAdditional"
      title="How much additional income do you have?"
      header="This helps us understand your income more fully."
      goBack={previousLocation}
      submitHandler={submit}
    >
      <div className="form__input">
        <CurrencyInput
          name="incomeAdditional"
          placeholder="(Optional)"
          helperText={helperText}
          label="Additional Income"
          defaultValue={incomeAdditional}
          onBlur={handleBlur}
          onChange={event => setIncomeAdditional(event.target.rawValue)}
          onFocus={handleFocus}
          errors={validationErrors.incomeAdditional}
          aria-invalid={Object.keys(validationErrors).length > 0 && !!validationErrors.incomeAdditional}
          autoFocus={!incomeAdditional}
        />
      </div>
    </Page>
  );
};

IncomeAdditional.propTypes = {
  saveValues: func.isRequired,
  previousLocation: func.isRequired,
  nextLocation: func.isRequired,
  incomeAdditional: string,
};

IncomeAdditional.defaultProps = {
  incomeAdditional: '',
};

export default IncomeAdditional;

